import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";

import CssBaseline from "@mui/material/CssBaseline";
import SearchBox from "../../common/components/SearchBox";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import {
  Typography,
  Box,
  Button,
  Menu,
  MenuItem,
  IconButton,
  Badge,
  Divider,
  TextField,
  Tooltip,
} from "@mui/material";
import { connect } from "react-redux";
import { CardContent, Toolbar } from "@mui/material";
import { useHistory } from "react-router-dom";
import {
  getOrganizationTypes,
  getTraingProviderAttachmentTypes,
  getPrograms,
  getSubPrograms,
  getVenues,
  getTraineeCategories,
  getTrainerCategories,
  getVenueTypes,
} from "../../../../store/cpd/actions";

import { getDistricts } from "../../../../store/posts/actions";

import OrganizationTypeCard from "../components/settings/OrganizationTypeCard";
import moment from "moment";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
import AttachmentTypeCard from "../components/settings/AttachmentTypeCard";
import ProgramCard from "../components/settings/ProgramCard";
import SubProgramCard from "../components/settings/SubProgramDialog";
import VenuesCard from "../components/settings/VenuesCard";
import TraineeCategoriesCard from "../components/settings/TraineeCategoriesCard";
import TrainerCategoriesCard from "../components/settings/TrainerCategoriesCard";

const Settings = (props) => {
  useEffect(() => {
    document.title = "TMIS | CPD Settings";
  }, []);

  const { hasPermissions } = useRequiredAuth();

  const {
    user,
    loading,
    getOrganizationTypes,
    getTraingProviderAttachmentTypes,
    getPrograms,
    getSubPrograms,
    getVenues,
    getDistricts,
    getTraineeCategories,
    getTrainerCategories,
    getVenueTypes,
  } = props;

  useEffect(() => {
    getOrganizationTypes();
    getTraingProviderAttachmentTypes();
    getPrograms();
    getSubPrograms();
    getVenues();
    getDistricts();
    getTraineeCategories();
    getTrainerCategories();
    getVenueTypes();
  }, []);

  return (
    <div>
      <AppBar position="static" elevation={0}>
        <Toolbar
          style={{
            minHeight: "0px",
          }}
          className=" my-0 py-1 bg-white mx-0"
        >
          <span className="text-uppercase text-primary font-weight-bolder">
            CPD Settings
          </span>
        </Toolbar>
      </AppBar>
      <div
        style={{
          backgroundColor: "#f3f4f6",
          borderRadius: "0.5rem",
          boxShadow: "0 5px 5px 0 rgb(42 119 144 / 5%)",
          MozBoxShadow: "0 5px 5px 0 rgba(42,119,144,.05)",
          height: "70vh",
          overflowY: "auto",
        }}
        className="p-3"
      >
        <div className="row mt-1">
          <div className="mb-3 col-12 col-lg-6">
            <ProgramCard />
          </div>
          <div className="mb-3 col-12 col-lg-6">
            <VenuesCard />
          </div>
          <div className="mb-3 col-12 col-lg-6">
            <OrganizationTypeCard />
          </div>
          <div className="mb-3 col-12 col-lg-6">
            <AttachmentTypeCard />
          </div>
          <div className="mb-3 col-12 col-lg-6">
            <TraineeCategoriesCard />
          </div>
          <div className="mb-3 col-12 col-lg-6">
            <TrainerCategoriesCard />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ user, loading }) => {
  return { user, loading };
};

export default connect(mapStateToProps, {
  getOrganizationTypes,
  getTraingProviderAttachmentTypes,
  getPrograms,
  getSubPrograms,
  getVenues,
  getDistricts,
  getTraineeCategories,
  getTrainerCategories,
  getVenueTypes,
})(Settings);
